import { render, staticRenderFns } from "./IssuedTask.vue?vue&type=template&id=00365cd1&scoped=true&"
import script from "./IssuedTask.vue?vue&type=script&lang=js&"
export * from "./IssuedTask.vue?vue&type=script&lang=js&"
import style0 from "./IssuedTask.vue?vue&type=style&index=0&id=00365cd1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00365cd1",
  null
  
)

export default component.exports